import type { ReactNode } from 'react';

export const symbol_atm: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M409-552h-56q-10 0-17-7t-7-17q0-10 7-17t17-7h160q10 0 17 7t7 17q0 10-7 17t-17 7h-56v168q0 10-7 17t-17 7q-10 0-17-7t-7-17v-168ZM128-437v53q0 10-7 17t-17 7q-10 0-17-7t-7-17v-182q0-15 9.5-24.5T114-600h139q15 0 24.5 9.5T287-566v182q0 10-7 17t-17 7q-10 0-17-7t-7-17v-53H128Zm0-48h111v-67H128v67Zm506-67v168q0 10-7 17t-17 7q-10 0-17-7t-7-17v-182q0-15 9.5-24.5T620-600h226q15 0 24.5 9.5T880-566v182q0 10-7 17t-17 7q-10 0-17-7t-7-17v-168h-75v126q0 10-7 17t-17 7q-10 0-17-7t-7-17v-126h-75Z"
		/>
	</svg>
);
